module.exports = __webpack_public_path__ + "static/media/logo-acorde-seguro-footer.3179be0e.png";